<template >
  <div class="send-message-container">
    <el-dialog :visible.sync="visible" :title="$t('Member.Desc.message')" left>
        <p>{{ $t('Choose.Member') }}：{{clientIds.length}}个</p>
        <p class="send-message-tips">{{ $t('Fill.send_message') }}</p>
        <el-form
            class="send-message-form"
            ref="form"
            :model="form"
            :rules="rules"
            :status-icon="true"
            label-position="right">
            <el-form-item prop="content">
                <el-input
                    type="textarea"
                    maxlength="294"
                    v-model="form.content" />
            </el-form-item>
            <p class="msg-p">
                {{ $t('Member.Desc.message_tip') }}
                <label style="float:right;">{{form.content ? form.content.length : 0}}/294</label>
            </p>
            <p class="mt-10 mb-10">{{ $t('Member.Desc.message_tip2') }}</p>
            <el-row :gutter="22" v-if="sure">
                <el-col :span="18">
                    <el-form-item prop="code">
                        <el-input :placeholder="$t('Fill.code')" type="text" v-model="form.code"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item prop="codeImg">
                        <img :src="codeImg" class="w-26 h-10" @click="refreshCodeImg()">
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer"  style="text-align:center">
            <el-button @click="submit" type="primary" v-if="!sure">{{ $t('Message.confirm') }}</el-button>
            <el-button @click="postData" type="primary" v-if="sure">{{ $t('Message.confirm') }}</el-button>
        </div>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog, Row, Col } from 'element-ui';

export default {
    props: ['type'],
    components: {
        ElDialog: Dialog,
        ElRow: Row,
        ElCol: Col,
    },
    data() {
        return {
            sure: false,
            codeImg: '',
            clientIds: [],
            loading: false,
            visible: false,
            content: '',
            form: {},
            rules: {
                content: { required: true, message: this.$t('Fill.message_content'), trigger: 'blur' },
                code: { required: true, message: this.$t('Fill.image_code'), trigger: 'blur' },
            },
        };
    },
    methods: {
        resetForm() {
            this.$refs.form.resetFields();
        },
        open(data) {
            if (data) {
                this.clientIds = data;
                this.visible = true;
            }
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.sure = true;
                this.refreshCodeImg();
            });
        },
        postData() {
            this.form.clientIds = this.clientIds;
            API.post('sms/send', this.form).then(() => {
                $ele.$message.success(this.$t('Message.send_success'));
                this.visible = false;
            });
        },
        refreshCodeImg() {
            this.codeImg = `${API.base_url}/kaptcha?${Math.random()}`;
        },
    },
};
</script>

<style lang="scss">
.send-message-container {
    p {
        font-size: 12px;
    }
    .el-dialog {
        width: 40%;
        left: 50%;
        top: 50%;
        background: #fff;
        box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.3);
        min-width: 258px;
        transform: translate(-50%, -50%);
        overflow-y: auto;
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .el-dialog__body {
        height: 50vh;
        overflow: auto;
    }
    .el-dialog__title {
        font-size: 16px;
    }
    .el-dialog__header {
        line-height: 40px;
        background-color: #f2f2f2;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        color: #333;
        text-align: left;
        padding: 0 45px 0 15px;
    }
    .msg-p {
        width: 100%;
    }
    .msg-s {
        position: relative;
        margin-right: 0px;
    }
    .send-message-tips {
        margin: 20px 0;
    }
    .send-message-form {
        .el-form-item {
            padding-right: 0;
        }
    }
}
</style>Î
